import classes from './UpButton.module.css'

function UpButton({ handleScrollToSection }) {
  return (
    <div className={classes.container}>
      <button
        className={`${classes.button} c_white bc_blue`}
        onClick={() => {
          handleScrollToSection('homePage')
        }}
      >
        Up
      </button>
    </div>
  )
}

export default UpButton
